import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ngx-calendar-header',
  template: `
    <div class="row text-center">
      <div class="col-md-3" style="text-align: left;">
        <div class="btn-group">
          <div nbTooltip="Previous" nbTooltipPlacement="bottom"
            class="btn  btn-violet btn-sm"
            mwlCalendarPreviousView
            [view]="view"
            [(viewDate)]="viewDate"
            (viewDateChange)="viewDateChange.next(viewDate)">
          <nb-icon icon="arrow-left-outline"></nb-icon>
          </div>
          <div
            nbTooltip="Today" nbTooltipPlacement="bottom"
            class="btn btn-violet-secondary btn-sm"
            mwlCalendarToday
            [(viewDate)]="viewDate"
            (viewDateChange)="viewDateChange.next(viewDate)" >
            <nb-icon icon="minus-circle-outline"></nb-icon>
          </div>
          <div
            nbTooltip="Next" nbTooltipPlacement="bottom"
            class="btn btn-violet btn-sm"
            mwlCalendarNextView
            [view]="view"
            [(viewDate)]="viewDate"
            (viewDateChange)="viewDateChange.next(viewDate)">
            <nb-icon icon="arrow-right-outline"></nb-icon>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <h6>{{ viewDate | calendarDate: view + 'ViewTitle':locale }}</h6>
      </div>
      <div class="col-md-3" style="text-align: right;">

   <nb-select placeholder="Select" status="info" ng-model [(selected)]="view" [(ngModel)]="view">
      <nb-option value="month"  (click)="viewChange.emit('month'); ">Month</nb-option>
      <nb-option value="week"  (click)="viewChange.emit('week')">Week</nb-option>
      <nb-option value="day" (click)="dayClicked()">Day</nb-option>
    </nb-select>

        <div class="btn-group" *ngIf="false">
          <div
            class="btn btn-primary"
            (click)="viewChange.emit('month')"
            [class.active]="view === 'month'"
          >
            Month
          </div>
          <div
            class="btn btn-primary"
            (click)="viewChange.emit('week')"
            [class.active]="view === 'week'"
          >
            Week
          </div>
          <div
            class="btn btn-primary"
            (click)="viewChange.emit('day')"
            [class.active]="view === 'day'"
          >
            Day
          </div>
        </div>
      </div>
    </div>
    <br />
  `,
  styles: [`
  .btn{ padding: 2px 2px !important; }
    
  `]
})
export class CalendarHeaderComponent {
  
  selectedItem="day";

  @Input() view: string;

  @Input() viewDate: Date;

  @Input() locale: string = 'en';

  @Output() viewChange: EventEmitter<string> = new EventEmitter();

  @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();

  @Output() dataEvent: EventEmitter<any> = new EventEmitter<any>();

  ngOnChanges(changes: any): void { 
    this.dataEvent.emit({
      viewDate:this.viewDate,
      view:this.view
    })
  }
  dayClicked(){
    this.viewChange.emit('day');
    this.viewDate=new Date();
  }
}
